import FJMathUtil from './FJMathUtil';
import FJUtil from './FJUtil';
import $ from 'jquery';
import FJPoolStore from '../store/FJPoolStore';
import FJImageUtil from './FJImageUtil';

const _getFitRect = (outerSize, innerSize) => {
    let size = FJMathUtil.fitSize(
        { width: outerSize.width, height: outerSize.height },
        { width: innerSize.width, height: innerSize.height },
    );
    let x = (outerSize.width - size.width) / 2;
    let y = (outerSize.height - size.height) / 2;
    return {
        x,
        y,
        width: size.width,
        height: size.height,
    };
};

const FJRenderUtil = {
    /**
     * @description 渲染图片缩略图
     * @param canvas
     * @param url
     * @return {Promise<unknown>}
     */
    renderImageThumbnail: async function (canvas, url) {
        const image = FJPoolStore.getImage();
        try {
            await FJImageUtil.loadImage(url, image);
            const imageSize = {
                width: image.naturalWidth,
                height: image.naturalHeight,
            };
            const { width, height } = _getFitRect(canvas, imageSize);
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            return imageSize;
        } catch (e) {
            FJUtil.isDev() && console.log(e);
        } finally {
            $(image).off();
            FJPoolStore.releaseImage(image);
        }
    },
    renderDecodedFrameToCanvas(canvas, frame, { width, height }, frameInfo) {
        canvas.width = width;
        canvas.height = height;
        const { frameType, dst_width, dst_height } = frameInfo || {};
        switch (frameType) {
            case 'ARRAYBUFFER':
            case 'TYPEDARRAY': {
                const buffer = frameType === 'ARRAYBUFFER' ? frame : frame.buffer;
                const size = dst_width * dst_height * 4;
                const frameData = new ImageData(new Uint8ClampedArray(buffer, 0, size), dst_width, dst_height);
                canvas.width = dst_width;
                canvas.height = dst_height;
                canvas.getContext('2d').putImageData(frameData, 0, 0);
                break;
            }
            case 'VIDEOFRAME': {
                canvas
                    .getContext('2d')
                    .drawImage(frame, 0, 0, frame.displayWidth, frame.displayHeight, 0, 0, width, height);
                frame.close && frame.close();
                break;
            }
            case 'CANVAS': {
                const ctx = canvas.getContext('2d');
                ctx.drawImage(frame, 0, 0, width, height);
                break;
            }
            default: {
                const ctx = canvas.getContext('bitmaprenderer');
                ctx.transferFromImageBitmap(frame);
                frame.close && frame.close();
            }
        }
    },
};

export default FJRenderUtil;
